import React, { useState } from 'react';

export default function Input({ label, className = '', type = 'text', ...props }) {
  const [show, setShow] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword && show ? 'text' : type;

  return (
    <label className="block w-full">
      {label && <span className="block mb-1 text-sm font-medium text-blue-gray-700">{label}</span>}
      <div className="relative">
        <input
          className={`w-full bg-white/60 border border-blue-gray-200 border-[1px] rounded-md px-3 py-2 text-sm font-sans placeholder-blue-gray-300 focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent focus:ring-offset-0 transition pr-10 ${className}`}
          type={inputType}
          {...props}
        />
        {isPassword && (
          <button
            type="button"
            tabIndex={-1}
            onClick={() => setShow((v) => !v)}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-blue-gray-400 hover:text-accent focus:outline-none"
            aria-label={show ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
          >
            {show ? (
              // Icône œil barré
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M3 3l18 18M10.7 10.7a2 2 0 002.6 2.6M6.4 6.4C4.5 7.8 3 10 3 12c0 2 3.6 7 9 7 1.7 0 3.2-.4 4.5-1.1M17.6 17.6C19.5 16.2 21 14 21 12c0-2-3.6-7-9-7-1.2 0-2.3.2-3.3.5" /><circle cx="12" cy="12" r="3" /></svg>
            ) : (
              // Icône œil
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" /><circle cx="12" cy="12" r="3" /></svg>
            )}
          </button>
        )}
      </div>
    </label>
  );
} 